import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';

/* eslint-disable import/no-absolute-path */
const renderCta = (viewportType, ctx) => {
    let isRendered = false;
    isRendered = viewportType === 'mobile' ? ctx.isMobile : !ctx.isMobile;
    ctx.requestUpdate();
    return isRendered ? x `<slot name="cta"></slot>` : null;
};
const renderLayout = (ctx) => x `<div class="header"><slot name="headline"></slot>${renderCta('desktop', ctx)}</div><div class="swiper"><div class="swiper-wrapper"></div><slot name="slide-container"></slot></div>${renderCta('mobile', ctx)}<lit-media-query .query="${ctx.query}" @changed="${ctx.handleMediaQuery}"></lit-media-query>`;

export { renderLayout };
